import { useQuery } from "@tanstack/react-query";
import type { Tone } from "@cx/ui";
import type { JobView } from "@cx/contracts";
import { useSession } from "./session";

/** Contrato da Task 8 (`GET /jobs`): o tipo vem de @cx/contracts para não divergir da API. */
export type Job = JobView;
export const JOB_KIND: Record<string, string> = {
  export_contacts: "Exportar contatos",
  export_products: "Exportar produtos",
  import_products: "Importar produtos",
  import_contacts: "Importar contatos",
  import_receivables: "Importar contas a receber",
  import_payables: "Importar contas a pagar",
  export_custom_report: "Exportar relatório",
  print_labels: "Imprimir etiquetas",
  export_bi: "Exportar BI",
};
/** Só as exportações e as etiquetas geram arquivo para baixar aqui; a importação tem os relatórios na tela dela. */
export const jobHasFile = (kind: string) => kind.startsWith("export_") || kind === "print_labels";
export const JOB_STATUS: Record<Job["status"], readonly [Tone, string]> = {
  queued: ["secondary", "Na fila"],
  running: ["info", "Executando"],
  done: ["success", "Concluída"],
  failed: ["danger", "Falhou"],
  canceled: ["secondary", "Cancelada"],
};

/** Jobs do próprio usuário (decisão 11). Repete a cada 2 s enquanto houver job na fila ou executando. */
export function useJobs() {
  const { companyId, api } = useSession();
  return useQuery({
    queryKey: ["jobs", companyId],
    queryFn: () => api<{ data: Job[] }>("/jobs"),
    refetchInterval: (q) =>
      q.state.data?.data.some((j) => j.status === "queued" || j.status === "running") ? 2000 : false,
  });
}
